import styled from 'styled-components';

// 적재 예시 3D 뷰어(로컬 알고리즘 버전) 전용 스타일.
// 기존 weget-pallet-canvas-v2 의 스타일과 독립적으로 관리한다.

export const Backdrop = styled.div`
    position: fixed;
    inset: 0;
    z-index: 1300;
    background: rgba(15, 23, 42, 0.62);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);

    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;

    @media all and (max-width: 768px) {
        padding: 0;
        align-items: stretch;
    }
`;

export const Modal = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 980px;
    height: min(88vh, 760px);
    background: #ffffff;
    border-radius: 18px;
    box-shadow: 0 24px 60px rgba(0, 0, 0, 0.35);
    overflow: hidden;

    @media all and (max-width: 768px) {
        max-width: 100%;
        height: 100%;
        border-radius: 0;
    }
`;

export const Header = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 18px;
    border-bottom: 1px solid #eef2f7;

    .titleGroup {
        display: flex;
        flex-direction: column;
        gap: 3px;
        min-width: 0;
    }

    .title {
        font-size: 16px;
        font-weight: 800;
        letter-spacing: -0.01em;
        color: #0f172a;
    }

    .subtitle {
        font-size: 12px;
        font-weight: 600;
        color: #94a3b8;
    }

    .spacer { flex: 1 1 auto; }

    .countBadge {
        flex: 0 0 auto;
        display: inline-flex;
        align-items: baseline;
        gap: 4px;
        padding: 5px 11px;
        border-radius: 999px;
        background: #eff6ff;
        color: #2563eb;
        font-size: 12px;
        font-weight: 700;

        b { font-size: 14px; font-weight: 800; }
    }
`;

export const CloseButton = styled.button`
    flex: 0 0 auto;
    width: 36px;
    height: 36px;
    border-radius: 10px;
    border: none;
    background: #f1f5f9;
    color: #475569;
    font-size: 20px;
    line-height: 1;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;

    &:hover { background: #e2e8f0; color: #0f172a; }
`;

export const Legend = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-wrap: wrap;
    gap: 6px 8px;
    padding: 10px 18px;
    border-bottom: 1px solid #f1f5f9;
    max-height: 92px;
    overflow-y: auto;

    .chip {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        padding: 4px 10px 4px 8px;
        border-radius: 999px;
        background: #f8fafc;
        border: 1px solid #eef2f7;
        font-size: 11.5px;
        font-weight: 600;
        color: #334155;
        max-width: 240px;

        .dot {
            flex: 0 0 auto;
            width: 10px;
            height: 10px;
            border-radius: 3px;
        }

        .name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .qty {
            flex: 0 0 auto;
            color: #94a3b8;
            font-weight: 700;
        }
    }
`;

export const CanvasArea = styled.div`
    flex: 1 1 auto;
    position: relative;
    min-height: 260px;
    background: radial-gradient(circle at 50% 30%, #f8fafc 0%, #e2e8f0 100%);

    canvas { display: block; }

    .empty {
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        color: #94a3b8;
        font-size: 13px;
        font-weight: 600;
    }

    .hint {
        position: absolute;
        left: 14px;
        bottom: 12px;
        padding: 5px 10px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.75);
        color: #64748b;
        font-size: 11px;
        font-weight: 600;
        pointer-events: none;
    }
`;

export const Controls = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: flex-end;
    gap: 10px;
    padding: 14px 18px;
    border-top: 1px solid #eef2f7;
    background: #fbfdff;

    .fields {
        flex: 1 1 auto;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px;
    }

    .field {
        display: flex;
        flex-direction: column;
        gap: 5px;

        span {
            font-size: 11px;
            font-weight: 700;
            color: #64748b;
        }

        .inputBox {
            display: flex;
            align-items: center;
            gap: 6px;
            height: 42px;
            padding: 0 10px;
            border: 1px solid #d8e0ea;
            border-radius: 10px;
            background: #fff;
            transition: border-color 0.15s, box-shadow 0.15s;

            &:focus-within {
                border-color: #2563eb;
                box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
            }

            input {
                width: 100%;
                border: none;
                outline: none;
                font-size: 15px;
                font-weight: 700;
                color: #0f172a;
                background: transparent;

                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
                -moz-appearance: textfield;
            }

            em {
                flex: 0 0 auto;
                font-style: normal;
                font-size: 11px;
                font-weight: 700;
                color: #94a3b8;
            }
        }
    }

    .apply {
        flex: 0 0 auto;
        height: 42px;
        padding: 0 20px;
        border: none;
        border-radius: 10px;
        background: #2563eb;
        color: #fff;
        font-size: 14px;
        font-weight: 800;
        cursor: pointer;
        transition: background 0.15s;

        &:hover { background: #1d4ed8; }
    }

    @media all and (max-width: 768px) {
        flex-wrap: wrap;
        .apply { width: 100%; }
    }
`;
